const currencySymbols = {
  SGD: "$",
  USD: "$",
  EUR: "€",
  GBP: "£",
  AUD: "$",
  NZD: "$",
  CAD: "$",
  DE: "€",
  EU: "€",
};

class CharityProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progressBar = this.querySelector("#charity-progress-bar");
    this.progressBarText = this.querySelector("#charity-progress-bar-text");
    this.currencySymbol = window.theme.shopCurrency;
    this.cartMessage = window.theme.charityBarText;
  }

  connectedCallback() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let cartSubtotal = data.total_price / 100;
        this.updateProgressBar(cartSubtotal);
      })
      .catch((error) => console.error("Error fetching cart data:", error));

    this.updateProgressBar = (cartSubtotal) => {
      this.maxValue = window.theme.charityBarAmount;
      this.threshold1 = this.maxValue / 4;
      this.threshold2 = this.threshold1 * 2;
      this.threshold3 = this.threshold1 * 3;
      this.threshold4 = this.threshold1 * 4;

      let progress = (cartSubtotal * 0.1).toFixed(2);
      let amount =
        currencySymbols[this.currencySymbol] + parseFloat(progress).toFixed(2);

      if (progress >= this.threshold4) {
        this.progressBar.style.width = "100%";
        this.progressBarText.innerHTML = this.cartMessage.replace(
          "__AMOUNT__",
          amount
        );
      } else if (progress > this.threshold3) {
        this.progressBar.style.width =
          ((progress - this.threshold3) / (this.threshold4 - this.threshold3)) *
            100 +
          "%";
        this.progressBarText.innerHTML = this.cartMessage.replace(
          "__AMOUNT__",
          amount
        );
      } else if (progress > this.threshold2) {
        this.progressBar.style.width =
          ((progress - this.threshold2) / (this.threshold3 - this.threshold2)) *
            100 +
          "%";
        this.progressBarText.innerHTML = this.cartMessage.replace(
          "__AMOUNT__",
          amount
        );
      } else if (progress > this.threshold1) {
        this.progressBar.style.width =
          ((progress - this.threshold1) / (this.threshold2 - this.threshold1)) *
            100 +
          "%";
        this.progressBarText.innerHTML = this.cartMessage.replace(
          "__AMOUNT__",
          amount
        );
      } else {
        this.progressBar.style.width = (progress / this.threshold1) * 100 + "%";
        this.progressBarText.innerHTML = this.cartMessage.replace(
          "__AMOUNT__",
          amount
        );
      }
    };
  }
}

customElements.define("charity-progress-bar", CharityProgressBar);